import * as React from 'react';
import { SubmitButton } from '../../../../components';
import { useFormikContext } from 'formik';
import { EFormStatus } from '../../../../constants';
import { jsx as _jsx } from "react/jsx-runtime";
export var SubmitActionContainer = function SubmitActionContainer(_ref) {
  var children = _ref.children;

  var _useFormikContext = useFormikContext(),
      isSubmitting = _useFormikContext.isSubmitting,
      isValid = _useFormikContext.isValid,
      dirty = _useFormikContext.dirty,
      status = _useFormikContext.status;

  var isButtonDisabled = !isValid && (!dirty || status === EFormStatus.QuestionSubmitted);
  return /*#__PURE__*/_jsx(SubmitButton, {
    loading: isSubmitting,
    disabled: isButtonDisabled,
    children: children
  });
};
SubmitActionContainer.displayName = 'SubmitActionContainer';